// import cookie from '../../lib/cookie.js'
import '../assets/scss/hosting.scss'
import KillistAdd from "./pages/KillistAdd"
import Spinner from 'vue-simple-spinner'
import Vue from "vue"
export default {
	components: {
		KillistAdd,
		Spinner
	},
	watch: {
		filterStatus(a, b) {
			if (a !== b) {
				this.setStatusFilter();
			}
		},
		perPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		currentPage(a, b) {
			if (a !== b) {
				// this.clearSelected();
			}
		},
		filter(a, b) {      
			if (a !== b) {
				// this.clearSelected();
			}
		},
	},
	
	data() {
			return {
				loading:false,
				checkedItems: [],
				tableValues: [],
				multichoice: '',
				sortBy: 'dd_domain',
				fields: [	
					{ key: 'dd_id', label: 'ID',sortable: true },
					{ key: 'dd_domain', label: 'Name',sortable: true },
					{ key: 'dd_status', label: 'Status', 'class': 'text-right'},
					{ key: 'actions', label: 'Actions', 'class': 'text-right'},
				],
				currentPage:1,
				pageOptions: [ 5, 10, 20, 50, 100 ],
				filter: null,
				modalInfo: { title: '', content: '' },
				showeditor: false,
				showadder: false,
				token: '',
				rows: [],
				dnsses:[],
				site: {},
				redirecturl: '',
				newsite: { },
				working:false,
				totalRows: 0,
				perPage: 20,	
				limit: 5,
				currentPage: 1,
				filterOptions: ['All','Open','Done'],
				filterStatus: 'All'
			};
	},

	created: function () {
		this.loading = true;
		this.getItems();
	},
	methods: {
		getItems() {
			let that = this
			this.$http.get("/websites/killist?status=" + this.filterStatus, { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
					//resolve({'loginError':resp.data.error})
				}
				else {
					that.totalRows = parseInt(resp.data.length)
					that.rows = resp.data
					that.dnsses = JSON.parse(JSON.stringify(that.rows))
					that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
					// that.showInventoryChunk(start)
					this.loading = false;
				}
			})
			.catch(err => {
				// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
				alert(err)
				this.loading = false;
			})
			
		},
		
		closeTheEditor() {
			this.showeditor = false;
			this.showadder = false;
		},
		showAdd() {
			this.showadder = true;
		},
		showEditor() {
			this.showeditor = true;
		},
		resetModal () {
			this.modalInfo.title = ''
			this.modalInfo.content = ''
		},

		details(index,item) {
			console.log(item)
			this.site = this.findItemById(item.DNS_ID)
			console.log(this.site)
			// this.site = this.inventory[index]
			this.showeditor = true;
		},


		updateSite(entry) {
			var that = this
			console.log(entry)
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/dns/edit',entry,headers)
			.then(function (response) {
				that.working = false;
				that.showeditor = false;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Update successful",
					position: "toast-top-center",
					type: "success"
				});
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},
		
		insertDeleteDomains(entry) {
			var that = this
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/dns/add',entry,headers)
			.then(function (response) {
				that.working = false;
				that.showadder = false;
				that.showeditor = false;
				// console.log(response)
				if(response.data['ID'] != '') entry['DNS_ID'] = parseInt(response.data['ID']) 
				that.dnsses.unshift(entry)
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Insert successful",
					position: "toast-top-center",
					type: "success"
				});
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showadder = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},

		deleteSite(sid) {
			var that = this
			console.log("deleting")
			let payload = {'DNS_ID': sid}
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/dns/delete',payload, headers)
			.then(function (response) {
				console.log(response)
				for(var i = 0;i < that.dnsses.length;i++) {
					if(that.dnsses[i].DNS_ID == sid) {
						that.dnsses.splice(i,1)
					}
				}
				that.showeditor = false;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Deletion successful",
					position: "toast-top-center",
					type: "success"
				});
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showeditor = false;
				 console.log(error)
			})			
			// alert(sid + "!!")
		},

		findItemById(sid) {
			for(var i = 0;i < this.dnsses.length;i++) {
				if(this.dnsses[i].DNS_ID == sid) {
					return this.dnsses[i]
				}
			}				
		}	

	},
	

	mounted() {
			
	}
}
